export const getSocialServiceResidualPercentsFrag = `
    id
    serviceTypeId
    percent
    validFrom
    validTo
`;
